<template>
  <div class="p-articleDetails">
    <div class="g-box">
      <!--返回上一页-->
      <div @click="$router.back()" class="back m-h">
        <img src="@/assets/img/news/icon_back.png" />
        <p>返回上一页</p>
      </div>
      <!--内容-->
      <div class="nav">
        <div class="left">
          <p class="left_title">{{ info.title }}</p>
          <p class="left_time">{{ info.tips }}</p>
          <div class="left_text" v-html="info.content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import page_mx from "@/mixin/page_mx";

export default {
  mixins: [page_mx],
  data() {
    return {};
  },
  methods: {
    init() {
      this.params = this.$route.params;
      this.getInfo();
    },
  },
};
</script>
<style lang="less" scoped>
.back {
  display: flex;
  align-items: center;
  margin-top: 61px;
  margin-bottom: 41px;
  p {
    width: 80px;
    height: 22px;
    font-size: 16px;
    font-weight: 400;
    color: #656878;
    line-height: 22px;
  }
}
.nav {
  display: flex;
  justify-content: space-between;
  padding-bottom: 120px;
}

.left_title {
  font-size: 32px;
  font-weight: 600;
  color: #000000;
  line-height: 45px;
  margin-bottom: 20px;
}
.left_time {
  font-size: 14px;
  font-weight: 400;
  color: #656878;
  line-height: 20px;
  margin-bottom: 40px;
}
.left_text {
  font-size: 16px;
  font-weight: 400;
  color: #000000;
  line-height: 28px;
  margin-bottom: 20px;
}
.left_img_text {
  width: 84px;
  height: 17px;
  font-size: 12px;
  font-weight: 400;
  color: #a8aab8;
  line-height: 17px;
  margin-bottom: 20px;
  text-align: center;
}

.img {
  width: 640px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.right {
  .line {
    width: 2px;
    height: 16px;
    background: #0030aa;
  }
}
.right_title {
  display: flex;
  align-items: center;
  .line_Y {
    width: 2px;
    height: 16px;
    background: #0030aa;
  }
  .right_title_text {
    width: 64px;
    height: 22px;
    font-size: 16px;
    font-weight: 400;
    color: #0030aa;
    line-height: 22px;
    margin-left: 3px;
  }
}
.line_X {
  width: 320px;
  height: 1px;
  background: #e3e3e7;
  margin: 20px 0;
}
.right_nav {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  .dian {
    width: 4px;
    height: 4px;
    background: #0030aa;
    margin-right: 10px;
  }
  .right_text {
    width: 306px;
    height: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #0030aa;
    line-height: 20px;
  }
}
</style>
